import { getMetaCarteirasFicFidcsConcentration } from 'src/services/meta-carteiras-fic-fidcs';

import type { FicFidcCockpitConcentrationV1Payload } from './contract';

export async function getFicFidcCockpitConcentration(
  operationId: string,
  competencyDate: string,
): Promise<FicFidcCockpitConcentrationV1Payload> {
  return getMetaCarteirasFicFidcsConcentration(operationId, competencyDate);
}
